import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import logo from "../images/logo.png";
import face from "../images/tiger-face.webp"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faPalette, faCartShopping } from "@fortawesome/free-solid-svg-icons";

const Header = ({ onOpenFAQ }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [logoModalOpen, setLogoModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  }

  const openLogoModal = () => {
    setLogoModalOpen(true);
  }

  const closeLogoModal = () => {
    setLogoModalOpen(false);
  }

  return (
    <header className={scrolled ? "scrolled" : ""}>
      <div className="header-inner">
        {/* Center Logo */}
        <div className={`logo ${scrolled ? "hidden" : ""}`} onClick={openLogoModal}>
          <img src={logo} alt="Tiger Logo" height="60" />
        </div>

        {/* Logo Modal */}
        <div className={`logo-modal ${logoModalOpen ? "active" : ""}`}>
          <div className="logo-modal-content">
            <div style={{ position: "relative", width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
              {/* Header */}
              <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px", padding: "0 20px" }}>
                <div style={{ flex: 1, height: "2px", background: "#fff" }}></div>
                <button className="logo-modal-close" onClick={closeLogoModal}>✕</button>
              </div>

              {/* Main */}
              <div style={{ display: "flex", gap: "40px", alignItems: "center", flex: 1, padding: "0 20px 20px" }}>
                {/* Tiger Image */}
                <div style={{ flex: "0 0 auto", maxWidth: "280px" }}>
                  <img src={face} alt="Tiger Face" style={{ width: "100%", height: "auto" }} />
                </div>

                {/* Right */}
                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "20px" }}>
                  {/* Text */}
                  <div>
                    <h2 style={{ margin: "0 0 8px 0", fontSize: "24px", fontWeight: "bold" }}>hi im chisel :)</h2>
                    <p style={{ margin: 0, fontSize: "16px" }}>check out my other links!</p>
                  </div>

                  {/* Buttons */}
                  <div style={{ display: "flex", gap: "16px" }}>
                    <a href="https://carrd.co/koyasumi" target="_blank" rel="noopener noreferrer" style={{ 
                      padding: "12px 24px", 
                      background: "#fff",
                      border: "3px solid #fff",
                      color: "#810100",
                      textDecoration: "none",
                      fontWeight: "bold",
                      fontSize: "16px",
                      cursor: "pointer",
                      transition: "all 0.3s"
                    }} onMouseOver={(e) => { e.target.style.background = "#810100"; e.target.style.color = "#fff"; }} onMouseOut={(e) => { e.target.style.background = "#fff"; e.target.style.color = "#810100"; }}>
                      CARRD
                    </a>
                    <button onClick={() => { closeLogoModal(); if (onOpenFAQ) onOpenFAQ(); }} style={{ 
                      padding: "12px 24px", 
                      background: "#fff",
                      border: "3px solid #fff",
                      color: "#810100",
                      textDecoration: "none",
                      fontWeight: "bold",
                      fontSize: "16px",
                      cursor: "pointer",
                      transition: "all 0.3s"
                    }} onMouseOver={(e) => { e.target.style.background = "#810100"; e.target.style.color = "#fff"; }} onMouseOut={(e) => { e.target.style.background = "#fff"; e.target.style.color = "#810100"; }}>
                      FAQ
                    </button>
                  </div>

                  {/* Social Icons */}
                  <div style={{ display: "flex", gap: "16px", marginTop: "12px" }}>
                    <a href="https://www.instagram.com/koyasumi" target="_blank" rel="noopener noreferrer" title="Instagram" style={{ width: "48px", height: "48px", borderRadius: "999px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", background: "#810100", color: "#fff", textDecoration: "none", transition: "all 0.3s" }} onMouseOver={(e) => { e.currentTarget.style.background = "#a80705"; }} onMouseOut={(e) => { e.currentTarget.style.background = "#810100"; }}><FontAwesomeIcon icon={faInstagram} /></a>
                    <a href="https://x.com/koyasumi" target="_blank" rel="noopener noreferrer" title="X" style={{ width: "48px", height: "48px", borderRadius: "999px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", background: "#810100", color: "#fff", textDecoration: "none", transition: "all 0.3s" }} onMouseOver={(e) => { e.currentTarget.style.background = "#a80705"; }} onMouseOut={(e) => { e.currentTarget.style.background = "#810100"; }}><FontAwesomeIcon icon={faXTwitter} /></a>
                    <a href="https://vgen.co/koyasumi" target="_blank" rel="noopener noreferrer" title="VGen" style={{ width: "48px", height: "48px", borderRadius: "999px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", background: "#810100", color: "#fff", textDecoration: "none", transition: "all 0.3s" }} onMouseOver={(e) => { e.currentTarget.style.background = "#a80705"; }} onMouseOut={(e) => { e.currentTarget.style.background = "#810100"; }}><FontAwesomeIcon icon={faPalette} /></a>
                    <a href="https://koyasumi.carrd.co" target="_blank" rel="noopener noreferrer" title="Shop" style={{ width: "48px", height: "48px", borderRadius: "999px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", background: "#810100", color: "#fff", textDecoration: "none", transition: "all 0.3s" }} onMouseOver={(e) => { e.currentTarget.style.background = "#a80705"; }} onMouseOut={(e) => { e.currentTarget.style.background = "#810100"; }}><FontAwesomeIcon icon={faCartShopping} /></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hamburger button (visible on mobile) */}
        <button
          type="button"
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation */}
        <nav id="main-nav" className={`${menuOpen ? "open" : ""}`}>
          <Link to="/" onClick={() => setMenuOpen(false)}>ILLUSTRATION</Link>
          <Link to="/projects" onClick={() => setMenuOpen(false)}>PROJECTS</Link>
          <Link to="/concept" onClick={() => setMenuOpen(false)}>CONCEPT</Link>
          <Link to="/misc" onClick={() => setMenuOpen(false)}>OTHER</Link>
          <Link to="/profile" onClick={() => setMenuOpen(false)}>ABOUT</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;